import React, { ReactElement } from 'react';
import {
  Button, Col, Row, LoaderButton,
} from 'idsk-react-components';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { useLocation, useNavigate, useParams } from 'react-router';
import routes from '../../../routing/routes';
import './addSubjektBezPripomienokFormButtons.scss';

interface Props {
  loading: boolean;
  onSubmit: () => void;
}

const AddSubjektBezPripomienokFormButtons = ({ onSubmit, loading }: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Row>
      <Col>
        <div className="add-subjekt-bez-pripomienok-admin__form-buttons-container">
          <ConfirmModal
            question="Naozaj si želáte odoslať za danú organizáciu spôsobom 'bez pripomienok'?"
            cancelButtonText="Nie"
            confirmButton={(<Button buttonStyle="action" size="large">Áno</Button>)}
            openButton={(
              <LoaderButton
                loading={loading}
                buttonStyle="action"
                type="button"
                size="large"
              >
                Pridať
              </LoaderButton>
            )}
            doAfterConfirm={onSubmit}
          />
          <Button
            onClick={() => {
              const hasPreviousState = location.key !== 'default';
              if (hasPreviousState) {
                navigate(-1);
              } else {
                navigate(routes.pripomienky.list.withParams(type, year, index));
              }
            }}
            type="reset"
            buttonStyle="secondary"
            size="large"
          >Zrušiť
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default AddSubjektBezPripomienokFormButtons;
